import React from 'react';
import { connect } from 'react-redux';
import { showModalMessage } from '../store/modalsSlice';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import WebViewerServerHistoryTable from '../components/webViewerServerHistoryTable';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { webViewerServersSelectors } from '../store/webViewerServersSlice';
import WebViewerServerHistoryTableHeader from '../components/webViewerServerHistoryTableHeader';

class WebViewerServerHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return 'Web viewer server history';
  }

  renderTable(tableProps) {
    return <WebViewerServerHistoryTable {...tableProps}/>
  }

  renderBeforeContent() {
    const objectData = this.props.selectedWebViewerServers(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <WebViewerServerHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }

  getLoaderMessage() {
    return 'Web viewer server history loading...';
  }
}

const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.webViewerServers(state),
  getEditedFields: () => objectHistorySelectors.webViewerServersEditedFields(state),
  selectedWebViewerServers: (id) => webViewerServersSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (webViewerServerId) => objectHistory.fetchHistory(webViewerServerId, objectHistoryNames.webViewerServers),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(WebViewerServerHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/webViewerServerHistoryDialog.js